import { h, Host } from "@stencil/core";
import api from "../../utils/api";
import { buildQueryString } from "../../utils/buildQueryString";
import { Label } from "../label/label";
/** static base className */
const baseClass = "ux-direct-searchbox";
/** uniqueId increment value */
let uidIncrement = 0;
/** create a unique component id */
const getUniqueId = () => `direct-searchbox-${(++uidIncrement).toString().padStart(3, "0")}`;
export class DirectSearchbox {
    constructor() {
        this.inputId = "";
        this.name = "q";
        this.label = "";
        this.labelInfo = "";
        this.placeholder = "";
        this.buttonText = "";
        this.url = "";
        this.disabled = false;
        this.error = false;
        this.pending = false;
        this.errorMsg = null;
        this.uniqueId = "";
        this.searchResult = null;
    }
    /** the searchbox dom element */
    domNode;
    componentWillLoad() {
        this.uniqueId = this.inputId || getUniqueId();
    }
    handleSearchResult() {
        if (this.searchResult === null) {
            return;
        }
        const { redirectUrl } = this.searchResult;
        if (redirectUrl !== undefined) {
            // @ts-expect-error Check for typing
            window.top.location.href = redirectUrl;
            return;
        }
        if (this.searchInput !== null) {
            this.searchInput.value = "";
        }
    }
    /** search input element */
    searchInput = null;
    componentDidLoad() {
        this.searchInput = this.domNode.querySelector("input[type=text]");
    }
    /** Send the request and handle response */
    requestData(url) {
        if (url === "" || this.searchInput === null || this.searchInput.value === "") {
            return;
        }
        const options = isMockUrl(url)
            ? {}
            : {
                method: "POST",
                body: buildQueryString({
                    // @ts-expect-error Check for typing
                    [this.name]: this.searchInput.value
                }),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
                }
            };
        this.errorMsg = null;
        this.error = false;
        this.pending = true;
        api(url, options)
            .then((data) => {
            if (data.result !== null) {
                this.searchResult = data.result;
            }
            else if (data.error !== null) {
                // @ts-expect-error Check for typing
                this.errorMsg = data.error.message;
                this.error = true;
            }
            this.pending = false;
        })
            .catch((error) => {
            this.errorMsg = error.message;
            this.error = true;
            this.pending = false;
        });
    }
    handleFormEvent(e) {
        switch (e.type) {
            case "change":
                this.error = false;
                break;
            case "submit":
                e.preventDefault();
                // @ts-expect-error Check for typing
                this.requestData(this.url);
                break;
            default:
                break;
        }
    }
    render() {
        const { label, labelInfo, error, errorMsg, disabled, pending, name, uniqueId } = this;
        return (h(Host, { key: '5e0370cbb629c32dd90d08a1a3a7e1f8d8c797ee', class: {
                [baseClass]: true,
                [`${baseClass}--disabled`]: disabled,
                [`${baseClass}--error`]: error,
                [`${baseClass}--pending`]: pending
            } }, h("form", { key: 'a89478ce07defd84462a6716527e6fbba712b18d', autoComplete: "off", autoCapitalize: "off", class: `${baseClass}-form`, "aria-disabled": disabled, "aria-invalid": error ? "true" : "false", onChange: (e) => this.handleFormEvent(e), onSubmit: (e) => this.handleFormEvent(e) }, h(Label, { key: '4c3d9a3e200dd23d0eb06010a37f6a21e1a1c94b', label: label, labelInfo: labelInfo, error: error, errorMsg: errorMsg, htmlFor: uniqueId }), h("div", { key: 'c642568fdb938ce1f81053a942080004693a6fc7', class: `${baseClass}-controls` }, h("input", { key: 'ca395644c3e31baf15232d26dc76ac62ab1ab3f6', class: {
                "ux-input": true,
                "is-error": error
            }, disabled: disabled, id: uniqueId, name: name, placeholder: this.placeholder, type: "text", "aria-invalid": error ? "true" : "false", onChange: (e) => this.handleFormEvent(e) }), h("span", { key: 'd4d3a1307d889699fd24b5773864ccd8f3862e2c', class: `${baseClass}-controls__spacer`, "aria-hidden": true }), h("button", { key: '005d7aed2a77010dc2cb173ee3d0397698ecc910', class: "ux-button ux-button--green", disabled: disabled, type: "submit" }, this.buttonText), pending && h("span", { key: 'dd37d1009bdd501deffc891d906efd9111c8e10c', class: "ux-spinner ux-spinner--absolute" })))));
    }
    static get is() { return "ux-direct-searchbox"; }
    static get originalStyleUrls() {
        return {
            "$": ["direct-searchbox.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["direct-searchbox.css"]
        };
    }
    static get properties() {
        return {
            "inputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "an optional unique id for the input element"
                },
                "attribute": "input-id",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "the input name"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"q\""
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "the input label text"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelInfo": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "additional info label for the the input field"
                },
                "attribute": "label-info",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "placeholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "the input placeholder text"
                },
                "attribute": "placeholder",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "buttonText": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "the submit button label"
                },
                "attribute": "button-text",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "url": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "the API endpoint from which data is requested"
                },
                "attribute": "url",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "flag that controls if the searchbox is disabled"
                },
                "attribute": "disabled",
                "reflect": true,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "flag that indicates that the search api has responded with an error"
                },
                "attribute": "error",
                "reflect": true,
                "defaultValue": "false"
            },
            "pending": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "flag that indicates a pending search request"
                },
                "attribute": "pending",
                "reflect": true,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "an error message which is rendered in error state"
                },
                "attribute": "error-msg",
                "reflect": true,
                "defaultValue": "null"
            }
        };
    }
    static get states() {
        return {
            "uniqueId": {},
            "searchResult": {}
        };
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "inputId",
                "methodName": "componentWillLoad"
            }, {
                "propName": "searchResult",
                "methodName": "handleSearchResult"
            }];
    }
}
function isMockUrl(url) {
    return url.includes("/mock-data/");
}
//# sourceMappingURL=direct-searchbox.js.map
